import { render } from "./PayoutMethods.vue?vue&type=template&id=ed731f5a&ts=true"
import script from "./PayoutMethods.vue?vue&type=script&lang=ts"
export * from "./PayoutMethods.vue?vue&type=script&lang=ts"

import "./PayoutMethods.vue?vue&type=style&index=0&id=ed731f5a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__